import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/initiate/matching.png'
import _imports_1 from '../../assets/images/initiate/ic_change.png'


const _withScopeId = n => (_pushScopeId("data-v-3d580cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "second-routerView" }
const _hoisted_2 = { class: "service-choose" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "请选择你要咨询的方向", -1))
const _hoisted_4 = { class: "service-type" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title flex" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("p", null, "企业领域")
], -1))
const _hoisted_6 = { class: "service-box flex j-s-e warp" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "choose-name flex f-d j-c" }
const _hoisted_10 = { class: "service-type" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title flex" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("p", null, "个人领域")
], -1))
const _hoisted_12 = { class: "service-box flex j-s-e warp" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "choose-name flex f-d j-c" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "正在为您匹配在线律师", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请您耐心等待...", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "match",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "matching" }, "匹配中")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "已为您匹配到当前律师", -1))
const _hoisted_20 = { class: "box" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "金牌律师,擅长领域", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更换", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

import { onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ArrowRight } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import { EnterpriseServiceRequest } from "@/services/datatype/business/service/request/EnterpriseServiceRequest";
import { KeywordEntity } from "@/services/datatype/keyword/KeywordEntity";
import { CoworkOp } from "@/services/datatype/cowork/CoworkOp";
import { ElMessage, ElMessageBox } from "element-plus";
import CheckType from "@/utils/CheckType";
import { EnterpriseServiceType } from "@/services/datatype/business/service/EnterpriseServiceType";

interface _AttorneyInfo {
  logo: string;
  entityName: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailChoose',
  setup(__props) {

const route = useRoute();
const $store = useStore();
const bread = reactive({
  ...$store.state.bread.bread,
});
let AttorneyInfo: _AttorneyInfo = reactive({
  logo: "",
  entityName: "",
});
const go = () => {
  router.push({
    path: "/layout/order",
  });
};
// 进入咨询条件
const requestId = ref<string | number>();
const servingProfessionalId = ref<string | number>();
// 匹配中的dialog 开关
const matchDialogState = ref(false);
const matchSuccessState = ref(false);
let HomeServiceList = reactive([]);
let UserServiceList = reactive([]);
const matchAttorney = async (keywords: string[]) => {
  $store.commit("servicerequest/updateKeyWord", keywords);
  let serviceRequestInfo = $store.state.servicerequest.serviceRequest;
  let serviceRequest = new EnterpriseServiceRequest();
  console.log(serviceRequest);
  serviceRequest.serviceType = serviceRequestInfo.serviceType;
  serviceRequest.tradeId = serviceRequestInfo.tradeId;
  serviceRequest.tradableId = serviceRequestInfo.tradableId;
  if (keywords && keywords.length > 0) {
    let keywordEntities = new Array<KeywordEntity>(keywords.length);
    let keywordEntity: KeywordEntity;
    for (var keyword of keywords) {
      keywordEntity = new KeywordEntity();
      keywordEntity.keyword = keyword;
      keywordEntities.push(keywordEntity);
    }
    serviceRequest.keywordEntities = keywordEntities;
  }
  serviceRequest.coworkOp = CoworkOp.CREATE;
  DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseServiceRequestService()
    .addEnterpriseServiceRequest(serviceRequest)
    .then((t) => {
      requestId.value = t.rid;
      servingProfessionalId.value = t.servingProfessionalInfo.entityId;
      AttorneyInfo = {
        logo: t.servingProfessionalInfo.logoImgUrl
          ? CheckType.isImg(t.servingProfessionalInfo.logoImgUrl)
          : "https://img2.baidu.com/it/u=3400399123,3298327378&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
        entityName: t.servingProfessionalInfo.entityName,
      };
      setTimeout(() => {
        matchDialogState.value = false;
        matchSuccessState.value = true;
      }, 2000);
    })
    .catch((error) => {
      ElMessage.error(error.errorMessage);
      matchDialogState.value = false;
      matchSuccessState.value = false;
      router.replace("/layout/order");
    });
  matchDialogState.value = true;
};
const router = useRouter();
const toTalk = () => {
  DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseServiceRequestService()
    .acceptServiceProvider(requestId.value, servingProfessionalId.value)
    .then((t) => {
      if (t == 7) {
        ElMessageBox.alert("请先购买套餐", "警告", {
          confirmButtonText: "确定",
        });
      } else if (t == 2) {
        DefaultWebServiceFactory.getInstance()
          .getWebEnterpriseServiceRequestService()
          .openMessageSessionOnServiceRequest(requestId.value)
          .then((t) => {
            // true
            if (t) {
              ElMessage.success("等待律师接受");
              router.push({
                path: "/layout/talk",
                query: {
                  rid: requestId.value,
                  code: "false",
                  breadType: "3",
                },
              });
            }
          });
      }
    });

  matchSuccessState.value = false;
};

const changeAttorney = () => {
  matchSuccessState.value = false;
  matchDialogState.value = true;
  setTimeout(() => {
    matchDialogState.value = false;
    matchSuccessState.value = true;
  }, 2000);
  DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseServiceRequestService()
    .requestToReassignServiceProvider(requestId.value)
    .then((t) => {
      AttorneyInfo = {
        logo: t.servingProfessionalInfo.logoImgUrl
          ? CheckType.isImg(t.servingProfessionalInfo.logoImgUrl)
          : "https://img2.baidu.com/it/u=3400399123,3298327378&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
        entityName: t.servingProfessionalInfo.entityName,
      };
      servingProfessionalId.value = t.servingProfessionalInfo.entityId;
    });
};
const getUserServiceList = (serviceType: EnterpriseServiceType) => {
  DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseServiceRequestService()
    .getServiceRequestClassifierByServiceType(serviceType, false)
    .then((t) => {
      console.log(t);
      t.classifierItems.forEach((r) => {
        if (Number(r.id) < 100) {
          UserServiceList.push(r);
        }
      });
    });
};
const getHomeServiceList = (serviceType: EnterpriseServiceType) => {
  DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseServiceRequestService()
    .getServiceRequestClassifierByServiceType(serviceType, true)
    .then((t) => {
      console.log(t);
      t.classifierItems.forEach((r) => {
        if (Number(r.id) < 100) {
          HomeServiceList.push(r);
        }
      });
    });
};

onMounted(() => {
  getHomeServiceList(Number(route.params.serviceType));
  getUserServiceList(Number(route.params.serviceType));
});

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_breadcrumb, { "separator-icon": _unref(ArrowRight) }, {
      default: _withCtx(() => [
        _createVNode(_component_el_breadcrumb_item, { onClick: go }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(bread.orderType), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(bread.orderState), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(bread.orderId), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["separator-icon"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HomeServiceList), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "flex j-s-e a-c choose-box",
              onClick: ($event: any) => (matchAttorney(item.keywords))
            }, [
              _createElementVNode("img", {
                src: _unref(CheckType).isImg(item.imgUrl),
                alt: ""
              }, null, 8, _hoisted_8),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.keywords, (item1, index1) => {
                  return (_openBlock(), _createElementBlock("p", { key: index1 }, _toDisplayString(item1), 1))
                }), 128))
              ])
            ], 8, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(UserServiceList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "choose-box flex j-s-e a-c",
                key: item.id,
                onClick: ($event: any) => (matchAttorney(item.keywords))
              }, [
                _createElementVNode("img", {
                  src: _unref(CheckType).isImg(item.imgUrl),
                  alt: ""
                }, null, 8, _hoisted_14),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.keywords, (item1, index1) => {
                    return (_openBlock(), _createElementBlock("p", { key: index1 }, _toDisplayString(item1), 1))
                  }), 128))
                ])
              ], 8, _hoisted_13))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      class: "matchdialog",
      modelValue: matchDialogState.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((matchDialogState).value = $event)),
      "show-close": false
    }, {
      default: _withCtx(() => [
        _hoisted_16,
        _createTextVNode(" 、 "),
        _hoisted_17,
        _hoisted_18
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "successdialog",
      modelValue: matchSuccessState.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((matchSuccessState).value = $event)),
      "show-close": false
    }, {
      default: _withCtx(() => [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("img", {
            src: _unref(AttorneyInfo).logo,
            alt: ""
          }, null, 8, _hoisted_21)
        ]),
        _createElementVNode("p", null, _toDisplayString(_unref(AttorneyInfo).entityName), 1),
        _hoisted_22,
        _createElementVNode("button", { onClick: toTalk }, "进入咨询"),
        _createElementVNode("p", { onClick: changeAttorney }, _hoisted_25)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})